import DealerList from "./DealerList";
import DealerTableHeader from "./DealerTableHeader";
import DealerTableBody from "./DealerTableBody";
import CustomPagination from "../../common/CustomPagination";
import { ChangeEvent, useEffect, useState, useCallback } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SilentRequest } from "@azure/msal-browser";
import DealerListSearch from "./DealerListSearch";
import { Company } from "../../data/interfaces/company";
import { getInactiveCompanies } from "../../data/companyService";
import CustomContainer from "../../common/CustomContainer";

const InactiveDealersPage = () => {
  const [fullCompaniesList, setFullCompaniesList] = useState<Company[]>([]);
  const [companiesList, setCompaniesList] = useState<Company[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(10);

  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const endIndex: number = pageNumber * pageSize;
  const startIndex: number = endIndex - pageSize;
  const currentPage: Company[] = companiesList.slice(startIndex, endIndex);
  const lastPage: number = Math.ceil(companiesList.length / pageSize);
  const disablePrevious: boolean = pageNumber === 1 ? true : false;
  const disableNext: boolean = currentPage.length < pageSize ? true : false;

  const getCompanies = useCallback(async () => {
    if (isAuthenticated) {
      const account = instance.getAllAccounts()[0];
      const silentRequest: SilentRequest = {
        scopes: ["api://a22e7296-106f-4a00-af8d-f86edb386a1b/api_access"],
        account: account,
      };

      const token = await instance.acquireTokenSilent(silentRequest);

      setIsLoading(true);
      const companies = await getInactiveCompanies(token.accessToken);

      setCompaniesList(companies);
      setFullCompaniesList(companies);

      setIsLoading(false);
    }
  }, [instance, setIsLoading, isAuthenticated]);

  useEffect(() => {
    getCompanies();
  }, [getCompanies]);

  const handleSearchChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const searchCriteria = event.target.value.trim();
    const companies = fullCompaniesList;

    const results = companies.filter(
      (company) =>
        company.accountNumber === Number(searchCriteria) ||
        company.companyName
          .toLocaleLowerCase()
          .includes(searchCriteria.toLocaleLowerCase())
    );

    setCompaniesList(results);
  };

  const next = () => {
    let nextPageNumber = pageNumber + 1;

    setPageNumber(nextPageNumber);
  };

  const previous = () => {
    let previousPageNumber = pageNumber - 1;
    setPageNumber(previousPageNumber);
  };

  return (
    <CustomContainer>
      {isAuthenticated === false ? (
        <div className="p-3 m-2">
          <h2>You must login to use this application.</h2>
        </div>
      ) : isLoading === false ? (
        <div>
          <h2 className="display-6 p-1 m-1">Inactive Company List</h2>
          <DealerListSearch handleSearchChange={handleSearchChange} />
          <DealerList>
            <DealerTableHeader />
            <DealerTableBody companies={currentPage} />
          </DealerList>
          <CustomPagination
            nextPage={next}
            previousPage={previous}
            currentPage={pageNumber}
            lastPage={lastPage}
            disableNextButton={disableNext}
            disablePreviousButton={disablePrevious}
          />
        </div>
      ) : (
        <div className="text-center">
          <h2>Loading...</h2>
        </div>
      )}
    </CustomContainer>
  );
};

export default InactiveDealersPage;
